// extracted by mini-css-extract-plugin
export default {"container":"ResultBase_container__af3DZ","title":"ResultBase_title__+Jett"};